module.exports = __webpack_public_path__ + "static/img/upload.7c893189.svg";